import { atom } from 'recoil';
import { sessionStorageEffect } from '@app/recoil';
import { UGCTileEntryProps } from '../types';

const entrieState = atom<UGCTileEntryProps[]>({
  key: 'entrieState',
  default: [],
  effects: [sessionStorageEffect('user_generated_content_entries_state')],
});

export default entrieState;
